<div class="filter-input-element">
  <input nz-input [(ngModel)]="value" (blur)="onChange($event)" />
</div>

<!-- 
<a nz-dropdown [nzDropdownMenu]="menuRef" nzPlacement="bottomLeft"
       
class="filter-dropdown">
  <i nz-icon nzType="filter" nzTheme="outline"></i>
</a>
<nz-dropdown-menu #menuRef="nzDropdownMenu">
<div class="dropdown-padding">

<ul nz-menu>
<li style="padding: 10px 10px 10px 10px;">
  <input nz-input 
  placeholder="Search in filters" class="filter-input">
</li>
<li nz-menu-item *ngFor="let itme of fieldFilterOprs">
<label nz-checkbox [ngModel]="itme.code">{{itme.label}}</label>
</li>
<li >
  <div class="buttons-container" style="display: flex;justify-content: space-between;
  padding: 10px 10px 10px 10px;">
      <button nz-button nzType="primary">Reset</button>
      <button nz-button nzType="default">OK</button>
    </div>
</li>
</ul>

</div>
</nz-dropdown-menu>

 -->
